import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/types";

const getOutboundCallState = (state: RootState) => state.outboundCall;

export const getIsCallEndedSelector = createSelector(
  [getOutboundCallState],
  (outboundCall) => outboundCall?.isCallEnded,
);
